import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyleRoot } from 'radium';

import Treebeard from './TreeBeard';
import decorators from './Decorators';
import DraggableGeographyNode from './DraggableGeographyNode';
import styles from './DynamicTreeStyles';
import * as messages from './../../../messages/DictionaryMessages';

const defaultValueForSelectedNodes = {
  INREGION: [],
  INSTATE: [],
  INMARKET: [],
  INCOUNTY: [],
  INZIP: [],
};
let selectedGeographyNodes = {
  INREGION: [],
  INSTATE: [],
  INMARKET: [],
  INCOUNTY: [],
  INZIP: [],
};

// Example: Customising The Header Decorator To Include Icons
decorators.GeographyHeader = props => {
  const { style, treeData } = props;
  let iconType = 'location';
  if (props.node.type !== 'L') {
    if (props.node.toggled) {
      iconType = 'folder-open';
    } else {
      iconType = 'folder';
    }
  }

  const iconClass = `node-icon node-icon-${iconType}`;
  // const iconStyle = { marginRight: '5px' };

  const getDeepCopy = defaultObj => {
    const defaultString = JSON.stringify(defaultObj);
    return JSON.parse(defaultString);
  };

  const handleMouseDown = (e, node) => {
    const nodeId = node.nodeId;
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey && !e.metaKey) {
      if (node.type === 'L') {
        if (
          node.parent === 100000 &&
          selectedGeographyNodes.INREGION.find(
            item => item.nodeId === nodeId,
          ) === undefined
        ) {
          selectedGeographyNodes = getDeepCopy(defaultValueForSelectedNodes);
          selectedGeographyNodes.INREGION.push(node);
          return selectedGeographyNodes;
        } else if (
          node.parent === 200000 &&
          selectedGeographyNodes.INSTATE.find(
            item => item.nodeId === nodeId,
          ) === undefined
        ) {
          selectedGeographyNodes = getDeepCopy(defaultValueForSelectedNodes);
          selectedGeographyNodes.INSTATE.push(node);
          return selectedGeographyNodes;
        } else if (
          node.parent === 300000 &&
          selectedGeographyNodes.INMARKET.find(
            item => item.nodeId === nodeId,
          ) === undefined
        ) {
          selectedGeographyNodes = getDeepCopy(defaultValueForSelectedNodes);
          selectedGeographyNodes.INMARKET.push(node);
          return selectedGeographyNodes;
        } else if (
          node.parent >= 400000 &&
          node.parent < 600000 &&
          selectedGeographyNodes.INCOUNTY.find(
            item => item.nodeId === nodeId,
          ) === undefined
        ) {
          selectedGeographyNodes = getDeepCopy(defaultValueForSelectedNodes);
          selectedGeographyNodes.INCOUNTY.push(node);
          return selectedGeographyNodes;
        } else if (
          node.parent >= 600000 &&
          selectedGeographyNodes.INZIP.find(item => item.nodeId === nodeId) ===
            undefined
        ) {
          selectedGeographyNodes = getDeepCopy(defaultValueForSelectedNodes);
          selectedGeographyNodes.INZIP.push(node);
          return selectedGeographyNodes;
        }
      }
    } else if ((e.ctrlKey || e.metaKey) && node.type === 'L') {
      if (node.parent === 100000) {
        if (
          selectedGeographyNodes.INREGION.find(
            item => item.nodeId === nodeId,
          ) !== undefined
        ) {
          selectedGeographyNodes.INREGION = [
            ...selectedGeographyNodes.INREGION.filter(
              item => item.nodeId !== nodeId,
            ),
          ];
        }
        selectedGeographyNodes.INREGION.push(node);
        return selectedGeographyNodes;
      } else if (node.parent === 200000) {
        if (
          selectedGeographyNodes.INSTATE.find(
            item => item.nodeId === nodeId,
          ) !== undefined
        ) {
          selectedGeographyNodes.INSTATE = [
            ...selectedGeographyNodes.INSTATE.filter(
              item => item.nodeId !== nodeId,
            ),
          ];
        }
        selectedGeographyNodes.INSTATE.push(node);
        return selectedGeographyNodes;
      } else if (node.parent === 300000) {
        if (
          selectedGeographyNodes.INMARKET.find(
            item => item.nodeId === nodeId,
          ) !== undefined
        ) {
          selectedGeographyNodes.INMARKET = [
            ...selectedGeographyNodes.INMARKET.filter(
              item => item.nodeId !== nodeId,
            ),
          ];
        }
        selectedGeographyNodes.INMARKET.push(node);
        return selectedGeographyNodes;
      } else if (node.parent >= 400000 && node.parent < 600000) {
        if (
          selectedGeographyNodes.INCOUNTY.find(
            item => item.nodeId === nodeId,
          ) !== undefined
        ) {
          selectedGeographyNodes.INCOUNTY = [
            ...selectedGeographyNodes.INCOUNTY.filter(
              item => item.nodeId !== nodeId,
            ),
          ];
        }
        selectedGeographyNodes.INCOUNTY.push(node);
        return selectedGeographyNodes;
      } else if (node.parent >= 600000) {
        if (
          selectedGeographyNodes.INZIP.find(item => item.nodeId === nodeId) !==
          undefined
        ) {
          selectedGeographyNodes.INZIP = [
            ...selectedGeographyNodes.INZIP.filter(
              item => item.nodeId !== nodeId,
            ),
          ];
        }
        selectedGeographyNodes.INZIP.push(node);
        return selectedGeographyNodes;
      }
    } else if (e.shiftKey && node.type === 'L') {
      if (node.parent === 100000) {
        if (
          selectedGeographyNodes.INREGION.length !== 0 &&
          selectedGeographyNodes.INREGION[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(item => item.nodeId === 100000);
          const targetArray = targetNode.children.map(
            nodeInTarget => nodeInTarget.nodeId,
          );
          const baseTarget = selectedGeographyNodes.INREGION[0].nodeId;
          if (targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)) {
            targetNodeIds = targetArray.slice(
              targetArray.indexOf(baseTarget),
              targetArray.indexOf(nodeId) + 1,
            );
          } else {
            targetNodeIds = targetArray.slice(
              targetArray.indexOf(nodeId),
              targetArray.indexOf(baseTarget) + 1,
            );
          }
          selectedGeographyNodes.INREGION = targetNode.children.filter(item =>
            targetNodeIds.includes(item.nodeId),
          );
          return selectedGeographyNodes;
        }
      } else if (node.parent === 200000) {
        if (
          selectedGeographyNodes.INSTATE.length !== 0 &&
          selectedGeographyNodes.INSTATE[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(item => item.nodeId === 200000);
          const targetArray = targetNode.children.map(
            nodeInTarget => nodeInTarget.nodeId,
          );
          const baseTarget = selectedGeographyNodes.INSTATE[0].nodeId;
          if (targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)) {
            targetNodeIds = targetArray.slice(
              targetArray.indexOf(baseTarget),
              targetArray.indexOf(nodeId) + 1,
            );
          } else {
            targetNodeIds = targetArray.slice(
              targetArray.indexOf(nodeId),
              targetArray.indexOf(baseTarget) + 1,
            );
          }
          selectedGeographyNodes.INSTATE = targetNode.children.filter(item =>
            targetNodeIds.includes(item.nodeId),
          );
          return selectedGeographyNodes;
        }
      } else if (node.parent === 300000) {
        if (
          selectedGeographyNodes.INMARKET.length !== 0 &&
          selectedGeographyNodes.INMARKET[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(item => item.nodeId === 300000);
          const targetArray = targetNode.children.map(
            nodeInTarget => nodeInTarget.nodeId,
          );
          const baseTarget = selectedGeographyNodes.INMARKET[0].nodeId;
          if (targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)) {
            targetNodeIds = targetArray.slice(
              targetArray.indexOf(baseTarget),
              targetArray.indexOf(nodeId) + 1,
            );
          } else {
            targetNodeIds = targetArray.slice(
              targetArray.indexOf(nodeId),
              targetArray.indexOf(baseTarget) + 1,
            );
          }
          selectedGeographyNodes.INMARKET = targetNode.children.filter(item =>
            targetNodeIds.includes(item.nodeId),
          );
          return selectedGeographyNodes;
        }
      } else if (node.parent >= 400000 && node.parent < 500000) {
        if (
          selectedGeographyNodes.INCOUNTY.length !== 0 &&
          selectedGeographyNodes.INCOUNTY[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(
            item => item.nodeId >= 400000 && item.nodeId < 500000,
          );
          if (targetNode.children) {
            const nodeFromHeirarchy = targetNode.children.find(
              item => item.nodeId === node.parent,
            );
            if (nodeFromHeirarchy.children) {
              const targetArray = nodeFromHeirarchy.children.map(
                nodeInTarget => nodeInTarget.nodeId,
              );
              const baseTarget = selectedGeographyNodes.INCOUNTY[0].nodeId;
              if (
                targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)
              ) {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(baseTarget),
                  targetArray.indexOf(nodeId) + 1,
                );
              } else {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(nodeId),
                  targetArray.indexOf(baseTarget) + 1,
                );
              }
              selectedGeographyNodes.INCOUNTY = nodeFromHeirarchy.children.filter(
                item => targetNodeIds.includes(item.nodeId),
              );
            }
          }
          return selectedGeographyNodes;
        }
      } else if (node.parent >= 500000 && node.parent < 600000) {
        if (
          selectedGeographyNodes.INCOUNTY.length !== 0 &&
          selectedGeographyNodes.INCOUNTY[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(
            item => item.nodeId >= 500000 && item.nodeId < 600000,
          );
          if (targetNode.children) {
            const nodeFromHeirarchy = targetNode.children.find(
              item => item.nodeId === node.parent,
            );
            if (nodeFromHeirarchy.children) {
              const targetArray = nodeFromHeirarchy.children.map(
                nodeInTarget => nodeInTarget.nodeId,
              );
              const baseTarget = selectedGeographyNodes.INCOUNTY[0].nodeId;
              if (
                targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)
              ) {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(baseTarget),
                  targetArray.indexOf(nodeId) + 1,
                );
              } else {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(nodeId),
                  targetArray.indexOf(baseTarget) + 1,
                );
              }
              selectedGeographyNodes.INCOUNTY = nodeFromHeirarchy.children.filter(
                item => targetNodeIds.includes(item.nodeId),
              );
            }
          }
          return selectedGeographyNodes;
        }
      } else if (node.parent >= 600000 && node.parent < 700000) {
        if (
          selectedGeographyNodes.INZIP.length !== 0 &&
          selectedGeographyNodes.INZIP[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(
            item => item.nodeId >= 600000 && node.parent < 700000,
          );
          if (targetNode.children) {
            const nodeFromHeirarchy = targetNode.children.find(
              item => item.nodeId === node.parent,
            );
            if (nodeFromHeirarchy.children) {
              const targetArray = nodeFromHeirarchy.children.map(
                nodeInTarget => nodeInTarget.nodeId,
              );
              const baseTarget = selectedGeographyNodes.INZIP[0].nodeId;
              if (
                targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)
              ) {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(baseTarget),
                  targetArray.indexOf(nodeId) + 1,
                );
              } else {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(nodeId),
                  targetArray.indexOf(baseTarget) + 1,
                );
              }
              selectedGeographyNodes.INZIP = nodeFromHeirarchy.children.filter(
                item => targetNodeIds.includes(item.nodeId),
              );
            }
          }
          return selectedGeographyNodes;
        }
      } else if (node.parent >= 700000) {
        if (
          selectedGeographyNodes.INZIP.length !== 0 &&
          selectedGeographyNodes.INZIP[0].nodeId !== nodeId
        ) {
          let targetNodeIds;
          const targetNode = treeData.find(item => item.nodeId >= 700000);
          if (targetNode.children) {
            let nodeFromHeirarchy;
            targetNode.children.forEach(item => {
              if (item.children) {
                nodeFromHeirarchy = item.children.find(
                  innerNode => innerNode.nodeId === node.parent,
                );
              }
            });
            if (nodeFromHeirarchy.children) {
              const targetArray = nodeFromHeirarchy.children.map(
                nodeInTarget => nodeInTarget.nodeId,
              );
              const baseTarget = selectedGeographyNodes.INZIP[0].nodeId;
              if (
                targetArray.indexOf(baseTarget) < targetArray.indexOf(nodeId)
              ) {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(baseTarget),
                  targetArray.indexOf(nodeId) + 1,
                );
              } else {
                targetNodeIds = targetArray.slice(
                  targetArray.indexOf(nodeId),
                  targetArray.indexOf(baseTarget) + 1,
                );
              }
              selectedGeographyNodes.INZIP = nodeFromHeirarchy.children.filter(
                item => targetNodeIds.includes(item.nodeId),
              );
            }
          }
          return selectedGeographyNodes;
        }
      }
    }
  };

  const getAllSelectedNodes = () => selectedGeographyNodes;

  const clearSelectedNodes = () =>
    (selectedGeographyNodes = getDeepCopy(defaultValueForSelectedNodes));

  if (props.node.type === 'L') {
    return (
      <div
        className="define-position"
        data-tooltip
        aria-haspopup="true"
        data-disable-hover="false"
        title={props.node.name.toUpperCase()}
        onMouseDown={e => handleMouseDown(e, props.node)}
      >
        <DraggableGeographyNode
          titleStyle={style.title}
          iconClass={iconClass}
          // iconStyle={iconStyle}
          name={props.node.name.toUpperCase()}
          node={props.node}
          getAllSelectedNodes={getAllSelectedNodes}
          clearSelectedNodes={clearSelectedNodes}
        />
      </div>
    );
  }

  return (
    <div
      className="define-color"
      style={style.base}
      data-tooltip
      aria-haspopup="true"
      data-disable-hover="false"
      title={props.node.name.toUpperCase()}
    >
      <div style={style.title}>
        <span className={iconClass} />
        {props.node.name.toUpperCase()}
      </div>
    </div>
  );
};

decorators.Header.propTypes = {
  style: PropTypes.shape({}),
  node: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    toggled: PropTypes.bool,
  }),
};

export default class DynamicGeographyTree extends Component {
  constructor(props) {
    super(props);
    this.state = { data: this.props.treedata ? [...this.props.treedata] : [] };
    this.onToggle = this.onToggle.bind(this);
    this.onFilterMouseUp = this.onFilterMouseUp.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.treedata !== nextProps.treedata) {
      this.setState({ data: [...nextProps.treedata] });
    }
  }
  onFilterMouseUp(e) {
    const filter = e.target.value.trim();
    if (!filter) {
      this.setState({ data: [...this.props.treedata] });
    } else {
      // let filtered = filters.filterTree(this.props.treedata, filter);
      // filtered = filters.expandFilteredNodes(filtered, filter);
      // this.setState({ data: filtered });
    }
  }
  onToggle(node, toggled) {
    const selectedNodes = [];
    Object.keys(selectedGeographyNodes).forEach(key => {
      if (selectedGeographyNodes[key].length !== 0) {
        selectedNodes.push(...selectedGeographyNodes[key]);
      }
    });
    if (
      selectedNodes.find(
        item => item.nodeId === node.nodeId && item.fname === node.fname,
      ) === undefined
    ) {
      selectedNodes.push(node);
    }
    const newNodes = selectedNodes.map(item => ({
      ...item,
      active: true,
    }));
    const allNewNodes = newNodes.map(item => {
      if (item.type !== 'L') {
        return {
          ...item,
          toggled,
        };
      }
      return item;
    });

    this.props.onNodeClicked(allNewNodes, this.currentCursor, false);
    this.currentCursor = allNewNodes.map(prev => ({
      ...prev,
      active: false,
    }));
  }

  render() {
    return (
      <StyleRoot>
        <div style={styles.component}>
          {this.state.data.length ? (
            <Treebeard
              data={this.state.data}
              onToggle={this.onToggle}
              tabSelected={this.props.tabSelected}
              decorators={decorators}
            />
          ) : (
            <p>{messages.NODATA_MESSAGE}</p>
          )}
        </div>
      </StyleRoot>
    );
  }
}

DynamicGeographyTree.propTypes = {
  onNodeClicked: PropTypes.func,
  treedata: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  tabSelected: PropTypes.string,
};
